import { HomeScreenType } from "../../helpers/Enums";
import DesktopNav from "../../components/DesktopNav";
import BottomNav from "../../components/BottomNav";
import MyProfile from "./components/MyProfile";


const MyProfileContainer = () => {
    return (
        <>
            <MyProfile />
            <DesktopNav screenType={HomeScreenType.MY_PROFILE} />
            <BottomNav screenType={HomeScreenType.MY_PROFILE} />
        </>
    )
}

export default MyProfileContainer;